export const PaperTexture = ({ className = "", children, style = {} }) => (
  <div className={`paper-bg relative rounded-[3px] ${className}`} style={style}>
    <div className="absolute inset-0 pointer-events-none opacity-[0.35]"
      style={{
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.4) 0%, transparent 30%, transparent 70%, rgba(0,0,0,0.03) 100%)",
      }}
    />
    {children}
  </div>
);

export default PaperTexture;
